import { FC,
   //useContext
   } from "react";
// import { useNavigate } from "react-router-dom";

import ContactAndSafetyInfo from "../contactAndSafetyInfo";
import { TextAlignProps } from "../contactAndSafetyInfo/types";
// import { AuthContext } from "src/context/authContext";
// import { HCPUserSubHeaderProps } from "src/types/users";

const AuthSubHeader: FC = (): JSX.Element => {
  // const navigate = useNavigate();
  // const { sub_header } = useContext(AuthContext);

  return (

    <div className="d-flex flex-column py-4 px-0 py-lg-4 px-lg-4">
        <ContactAndSafetyInfo textColor="black" alignText={TextAlignProps.TEXT_END} />
    </div>

  );
};

export default AuthSubHeader;
